/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

var overflowScrollReg = /scroll|auto|overlay/i;
function getScrollParent(el) {
  var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var node = el;
  while (node && node !== root && node.nodeType === 1) {
    var _window$getComputedSt = window.getComputedStyle(node),
      overflowY = _window$getComputedSt.overflowY;
    if (overflowScrollReg.test(overflowY)) {
      return node;
    }
    node = node.parentNode;
  }
  return root;
}

export { getScrollParent as default };
//# sourceMappingURL=getScrollParent.js.map
